import { toast } from 'react-toastify';
import { partApi } from 'features/getParticipants/api/model/usersApi';

type deleteParticipantRequestType = {
  id: string;
  body: {
    participant_id: number;
  };
};

const deleteParticipantApi = partApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteParticipant: builder.mutation<any, deleteParticipantRequestType>({
      query: ({ id, body }) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/${id}/remove_participant/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили торговую точку', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['PartPromo'];
      },
    }),
  }),
});

export const { useDeleteParticipantMutation } = deleteParticipantApi;
